import {LiveSwitchClickEvent} from "../models/events/live-switch-click-event";
import {ACTION_TYPES} from "../consts";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {RouteModel} from "../components/router/models/route-model";
import {RouterController} from "../components/router/router-controller";
import {ActionHandler} from "../../infrastructure/handlers/action-handler";
import {BaseLinkModel} from "../../infrastructure/models/link/base-link-model";

export class LiveSwitchClickHandler extends ActionHandler {
  type = ACTION_TYPES.liveSwitchClick;
  analyticsService: AnalyticsService;
  routerController: RouterController;

  static injectables = [...ActionHandler.injectables, AnalyticsService, RouterController];

  constructor(analyticsService: AnalyticsService, routerController: RouterController) {
    super(analyticsService);

    this.routerController = routerController;
    this.analyticsService = analyticsService;
  }

  async action(params) {
    this._handleAnalyticsEvent(params);

    if (!params.skipNavigation) {
      this._handleRouteChange();
    }
  }

  _handleAnalyticsEvent(params) {
    const clickEvent = new LiveSwitchClickEvent(params);

    this.analyticsService.createEvent(clickEvent);
  }

  _handleRouteChange() {
    const linkModel: BaseLinkModel = this.state.isLive ? this.state.allScoresLinkModel : this.state.liveScoresLinkModel;
    const route: RouteModel = this.routerController.findRouteByName(linkModel.name);
    const replace: Boolean = !this.routerController.isFormalRoute(route);

    this.navigationManager.gotoRoute(route, linkModel, replace);
  }
}
